import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { branch } from '@app/_models/branch';
import { headervalue } from 'src/headervalue/header';
import {Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders(headervalue.headerWithJwt)
};

@Injectable({ providedIn: 'root' })


export class BranchService {
  url: string;
  constructor(private http: HttpClient) { }

  getBranch() {
    var temp = this.http.get<any>(`${environment.apiUrl}/branch/getAllBranchList`);
    return temp;
  }
  

  addBranch(branchParam: branch): Observable<branch> {
    return this.http.post<branch>(`${environment.apiUrl}/branch/saveBranch`,branchParam, httpOptions).pipe( );
  }

  updateBranch(branchParam: branch): Observable<branch> {
    return this.http.post<branch>(`${environment.apiUrl}/branch/updateBranch`,branchParam, httpOptions).pipe( );
  }

  deleteBranch(id) {
    return this.http.delete<branch>(`${environment.apiUrl}/branch/deleteBranch/`+id, httpOptions).pipe( );
  }


}